// Hari K:08-11-2023 :BT-119138:Funds View -mandate report modal-start
import { memo } from "react";
import { BzButton, BzChip, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleModal } from "../../redux/actions/modals";
import MandateDetailsModal from "./MandateDetailsModal";



const MandateReportModal = () => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state.modals.modals);
    const onHide = () => {
        dispatch(handleModal([{ "MANDATE_REPORT_MODAL": false }]));
    };

    const handleOnClick = () => {
        dispatch(handleModal([{ "MANDATE_DETAILS_MODAL": true }]));
    };

    const mandateReport = [
        {
            id: "1",
            amount: 503,
            status: "Rejected",
            usedAmount: 0,
        },
        {
            id: "2",
            amount: 502,
            status: "Registered by Member",
            usedAmount: 0,
        },
        {
            id: "3",
            amount: 500,
            status: "Rejected",
            usedAmount: 0,
        },
    ];

    return (
        <>
            {/* SumitG-08-12-23 */}
            <BzModal show={modals['MANDATE_REPORT_MODAL']} onHide={onHide}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={10} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>Mandate Report</div>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-self-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <div className='transparent-card-wrap'>
                            {
                                mandateReport?.map((each, index) => (
                                    <div key={index} className='transparent-card cursor-pointer bdr-btm' onClick={() => handleOnClick()}>
                                        <Row className='g-0  p-2'>
                                            <Col md={9} className='d-flex flex-column align-items-start'>
                                                <div className='font-medium font-size5 color-text text-uppercase'>E-Mandate</div>
                                                <div className='font-medium font-size2 color-text pt-1'>Used Amount - {each.usedAmount}</div>
                                            </Col>
                                            <Col md={3} className='d-flex justify-content-end align-items-start'>
                                                <div className='font-medium font-size4 color-text'>{each.amount}</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mt-1'>
                                            <Col md={9} className='d-flex justify-content-start align-items-center'>
                                                <div className='multi-chips-wrap'>
                                                    <div className='chips-wrap'>
                                                        <BzChip className='chips text-capitalize positive-chip'>{each.status}</BzChip>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={3} className='d-flex justify-content-end align-items-center'>
                                                <BzButton className='btn btn-md btn-primary btn-rounded'>Download</BzButton>
                                            </Col>
                                        </Row>
                                    </div>
                                ))
                            }
                        </div>
                    </Container>
                </BzModalBody>
                <BzModalFooter className='bdr-none'>
                    <Container fluid className='p-0 m-0'>
                        <Row className='g-0'>
                            <Col className='d-flex'>
                                <BzButton className='btn btn-md btn-outline btn-block text-capitalize'>Register Mandate</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
            <MandateDetailsModal />
        </>
    );
};

export default memo(MandateReportModal);

// Hari K:08-11-2023 :BT-119138:Funds View -mandate report modal-end